import { useQuery, UseQueryResult } from 'react-query';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

type ManagedOrganizationsInterface = {
    orgName: string,
    orgId: string,
    inviteDate: string,
    accountStatus: string,
}[]

const useGetManagedOrganizations = (
  identifier: string,
  shouldFetch: boolean,
): UseQueryResult<ApiResponse<ManagedOrganizationsInterface>, ApiError<ManagedOrganizationsInterface>> => useQuery<ApiResponse<ManagedOrganizationsInterface>, ApiError<ManagedOrganizationsInterface>>(
  [`managed_organizations_${identifier}`],
  () => dataFetch.get(`${DIGGER_API_SUFFIX}managerial-accounts/manager-accounts`),
  {
    enabled: shouldFetch,
  },
);

export default useGetManagedOrganizations;
